export default [
  {
    for: 'article',
    actions: {
      create: true,
      update: true,
      read: true,
    },
  },
];
